import { CallbackMessage } from '../CallbackMessage'

const success = (email: string) => 'Successfully logged in as ' + email

/** `/auth/oase-callback`: the EWS/Graph popup target; posts on `ewsEmail` (portal pages/auth/oase-callback.tsx). */
export function OaseCallbackPage() {
  return (
    <CallbackMessage
      channel="ewsEmail"
      success={success}
      missing="No email address found in callback url"
    />
  )
}
